import { useEffect, useState, useRef } from 'react';

import _ from 'lodash';
import { DateTime } from 'luxon';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';

import { useGetMarksQuery } from '@school_ify/schoolify-repository/src/teacher/types';

import GradesModal from 'views/Dashboard/components/Upcoming/components/GradesModal/GradesModal';
import './PeriodsTable.scss';
import useGrading from 'application/teacher/dashboard/assignments/useGrading';
import { useUpcoming } from 'application/dashboard/upcomings/upcoming.context';

import TableRow from './components/TableRow/TableRow';

interface PeriodsTableProps {
  grades?: any;
  subject?: any;
  onGradesUpdate: () => void;
}

const PeriodsTable: React.FC<PeriodsTableProps> = ({ subject, grades, onGradesUpdate }) => {
  const [popoverOpened, setPopoverOpened] = useState('');
  const [students, setStudents] = useState({});
  const [dates, setDates] = useState({});
  const [marks, setSetMarks] = useState([]);
  const [modal, toggleModal] = useState(false);
  const [currentAssignment, setCurrentAssignment] = useState({});
  const marksData = useGetMarksQuery();
  const scrollContainer = useRef(null);
  const { t } = useTranslation();
  const { addStudentGrade } = useGrading();
  const { getAssignments } = useUpcoming();

  const handleTableScroll = () => {
    if (popoverOpened !== '') {
      setPopoverOpened('');
    }
  };

  useEffect(() => {
    if (marksData.loading) {
      return;
    }

    setSetMarks(
      _.orderBy(
        marksData.data.marks.map(obj => {
          return {
            label: obj.name,
            value: obj.id,
          };
        }),
        ['label'],
        ['asc']
      )
    );
  }, [marksData.loading]);

  useEffect(() => {
    setDates(
      _.groupBy(grades, function (obj) {
        return obj.assignment.title;
      })
    );

    setStudents(
      _.groupBy(_.orderBy(grades, ['student.user.full_name']), function (obj) {
        return obj.student?.user?.full_name;
      })
    );
  }, [grades]);

  useEffect(() => {
    getAssignments('change', {});
  }, []);

  const clicked = str => {
    setCurrentAssignment(str);
    toggleModal(true);
  };

  return (
    <>
      <GradesModal
        openModal={modal}
        handleModal={() => {
          toggleModal(!modal);
          onGradesUpdate();
        }}
        assignment={currentAssignment}
        onInputChange={(id, mark) => addStudentGrade(id, mark)}
      />

      <div key={subject} className="grade-periods">
        <div className="subject-title">{subject && subject.teaching_structure.title}</div>
        {grades.length ? (
          <div ref={scrollContainer} onScroll={handleTableScroll} className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th></th>
                  {_.orderBy(
                    Object.values(dates),
                    [obj => new Date(obj[0].assigment_date)],
                    ['asc']
                  ).map(str => {
                    const formattedDate = DateTime.fromISO(str[0].assigment_date).toFormat(
                      'MM.dd.y'
                    );
                    return (
                      <th key={`${str[0].assigment_date}_dates`}>
                        <div onClick={() => clicked(str[0].assignment)} className="cursor-pointer">
                          {DateTime.fromFormat(formattedDate, 'MM.dd.y')
                            .setLocale(i18n.language)
                            .toFormat('dd.MM')}
                        </div>
                      </th>
                    );
                  })}
                  <th>Average</th>
                </tr>
              </thead>

              <tbody>
                {Object.keys(students).map(student => {
                  return (
                    <TableRow
                      popoverOpened={popoverOpened}
                      setPopoverOpened={setPopoverOpened}
                      key={`${student}_row`}
                      student={student}
                      subject={subject}
                      marks={marks}
                      dates={dates}
                    />
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="assignments-missing">{t('grades:No_assignments')}</div>
        )}
      </div>
    </>
  );
};

export default PeriodsTable;
